import { FunctionComponent } from "react";
import i18n from "i18next";
import HierarchyTreeView from "../HierarchyTreeView/HierarchyTreeView";
import {
  getDisplayName,
  getOrganizationKey,
  OrganizationFilterResult,
} from "../../utils/organizationTree";

type OrganizationTreeViewProps = {
  filteredTree: OrganizationFilterResult;
  collapsedNodes: Record<string, boolean>;
  normalizedSearchTerm: string;
  onToggleNode: (key: string) => void;
  onGoToOrganizationDetails: (organizationId?: string | null) => void;
};

const OrganizationTreeView: FunctionComponent<OrganizationTreeViewProps> = ({
  filteredTree,
  collapsedNodes,
  normalizedSearchTerm,
  onToggleNode,
  onGoToOrganizationDetails,
}) => {
  return (
    <HierarchyTreeView
      filteredTree={filteredTree}
      collapsedNodes={collapsedNodes}
      normalizedSearchTerm={normalizedSearchTerm}
      onToggleNode={onToggleNode}
      onGoToDetails={onGoToOrganizationDetails}
      getKey={getOrganizationKey}
      getDisplayName={getDisplayName}
      labels={{
        open: i18n.t("label.openorganization"),
        close: i18n.t("label.closeorganization"),
        details: i18n.t("label.details"),
        root: i18n.t("label.root"),
        level: i18n.t("label.level"),
        subItems: i18n.t("label.suborganizations"),
        leaf: i18n.t("label.leaf"),
        identifier: i18n.t("label.identifier"),
        parentIdentifier: i18n.t("label.parentidentifier"),
        rootValue: "ROOT",
      }}
    />
  );
};

export default OrganizationTreeView;
